/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import * as ActionTypes from '../ActionTypes';
import KnowledgeCategoriesApi from '../../api/KnowledgeCategories';
import { showErrorNotification } from '../Notifications';
import { getMultiLanguageCategories } from './MultiLanguageCategoryActions';
import { templatePreviewShowLoadingOverlay, templatePreviewTriggerIFrameReload } from '../TemplateEditorActions';
function categoriesReceived(response) {
  return {
    type: ActionTypes.FETCH_CATEGORIES_ORGANIZATION_SUCCESS,
    payload: response
  };
}
function categoriesRequesting() {
  return {
    type: ActionTypes.FETCH_CATEGORIES_ORGANIZATION_PENDING
  };
}
function categoriesRequestFailed(error) {
  return {
    type: ActionTypes.FETCH_CATEGORIES_ORGANIZATION_ERROR,
    error
  };
}
export function stateTranslatedCategoriesJson(hydratedCategory, totalPublishedArticles, selectedCategoryId, translatedParentCategories) {
  return {
    type: ActionTypes.FETCH_TRANSLATED_CATEGORY_SUCCESS,
    payload: {
      hydratedCategory,
      totalPublishedArticles,
      selectedCategoryId,
      translatedParentCategories
    }
  };
}
function stateInitialTranslatedCategoriesJson(response) {
  return {
    type: ActionTypes.FETCH_TRANSLATED_CATEGORIES_SUCCESS,
    payload: response
  };
}
export function getCategoryOrganization() {
  return dispatch => {
    dispatch(categoriesRequesting());
    KnowledgeCategoriesApi.getCategoryOrganization().then(response => dispatch(categoriesReceived(response)), error => {
      console.error(error);
      dispatch(showErrorNotification('getCategories'));
      dispatch(categoriesRequestFailed(error));
    });
  };
}
export function getCategories(language, knowledgeBaseId) {
  return dispatch => {
    dispatch(getMultiLanguageCategories({
      languages: [language],
      knowledgeBaseId
    }));
  };
}
export function translatedCategoriesReceivedWithArticles(response) {
  return {
    type: ActionTypes.FETCH_TRANSLATED_CATEGORY_ORGANIZATION_SUCCESS,
    payload: response
  };
}
export function translatedCategoriesReceived(response) {
  return {
    type: ActionTypes.FETCH_TRANSLATED_CATEGORY_ORGANIZATION_SUCCESS,
    payload: response
  };
}
export function parentSubcategoriesReceived(response) {
  return {
    type: ActionTypes.FETCH_SUBCATEGORIES_FOR_PARENT_SUCCESS,
    payload: response
  };
}
export function translatedCategoriesRequesting() {
  return {
    type: ActionTypes.FETCH_TRANSLATED_CATEGORY_ORGANIZATION_PENDING
  };
}
export function translatedCategoriesRequestFailed(error) {
  return {
    type: ActionTypes.FETCH_TRANSLATED_CATEGORY_ORGANIZATION_ERROR,
    error
  };
}
export function getTranslatedCategoryOrganizationWithArticles(knowledgeBaseId, lang) {
  return dispatch => {
    dispatch(translatedCategoriesRequesting());
    return KnowledgeCategoriesApi.getTranslatedCategoryOrganizationWithArticles(knowledgeBaseId, lang).then(response => dispatch(translatedCategoriesReceivedWithArticles(response)), error => {
      console.error(error);
      dispatch(showErrorNotification('getCategoryOrganization'));
      dispatch(translatedCategoriesRequestFailed(error));
    });
  };
}
export function getHydratedTranslatedCategory(knowledgeBaseId, selectedCategoryId, categoryOrganization, hasLocalChanges, lang) {
  return dispatch => {
    const INIT_CACHE = {
      primaryLanguage: lang,
      requestedLanguage: lang,
      categories: [],
      hydrated: []
    };
    const translatedParentCategories = categoryOrganization.translatedParentCategories || INIT_CACHE;
    if (!hasLocalChanges && translatedParentCategories.hydrated.includes(selectedCategoryId)) {
      dispatch(translatedCategoriesReceived(translatedParentCategories));
    } else {
      dispatch(translatedCategoriesRequesting());
      KnowledgeCategoriesApi.getHydratedTranslatedCategory(knowledgeBaseId, lang, selectedCategoryId).then(result => {
        const totalPublishedArticles = categoryOrganization.categories.get(selectedCategoryId).totalPublishedArticles;
        dispatch(stateTranslatedCategoriesJson(result, totalPublishedArticles || 0, selectedCategoryId, translatedParentCategories));
        dispatch(translatedCategoriesReceived(translatedParentCategories));
      }, error => {
        console.error(error);
        dispatch(showErrorNotification('getCategoryOrganization'));
        dispatch(translatedCategoriesRequestFailed(error));
      });
    }
  };
}
export function getTranslatedCategoryOrganization(knowledgeBaseId, lang, selectedCategoryId = null) {
  return dispatch => {
    dispatch(translatedCategoriesRequesting());
    return KnowledgeCategoriesApi.getTranslatedCategoryOrganization(knowledgeBaseId, lang).then(response => {
      const {
        categories
      } = response;
      if (response.categories.length <= 0) {
        dispatch(translatedCategoriesReceived(response));
        return;
      }
      const firstCategoryId = categories[0].id;
      const categoryId = selectedCategoryId || firstCategoryId;
      const selectedCategoryIndex = categories.findIndex(cat => cat.id === categoryId);
      const selectedCategory = categories[selectedCategoryIndex];
      const KbLanguage = lang || response.primaryLanguage;
      //Skip category hydration if the category is not translated to the requested language or there's no categories
      if (selectedCategory && selectedCategory.translatedToLanguages.includes(KbLanguage)) {
        //adding subcategories and articles properties while we support KBv2 and KBv3 API endpoints
        response.categories.forEach(category => {
          category.subcategories = [];
          category.articles = [];
        });
        KnowledgeCategoriesApi.getHydratedTranslatedCategory(knowledgeBaseId, lang, categoryId).then(result => {
          categories[selectedCategoryIndex] = Object.assign({}, selectedCategory, result.categories[0]);
          dispatch(stateInitialTranslatedCategoriesJson(Object.assign({}, response, {
            hydrated: [categoryId]
          })));
          dispatch(translatedCategoriesReceived(response));
        }).catch(error => {
          console.error(error);
          dispatch(showErrorNotification('getCategoryOrganization'));
          dispatch(translatedCategoriesRequestFailed(error));
        });
      } else {
        dispatch(translatedCategoriesReceived(response));
      }
    }).catch(error => {
      console.error(error);
      dispatch(showErrorNotification('getCategoryOrganization'));
      dispatch(translatedCategoriesRequestFailed(error));
    });
  };
}
function categoryDeleted() {
  return {
    type: ActionTypes.DELETE_CATEGORY_SUCCESS
  };
}
function categoryDeleting() {
  return {
    type: ActionTypes.DELETE_CATEGORY_PENDING
  };
}
function categoryDeleteRequestFailed(error) {
  return {
    error,
    type: ActionTypes.DELETE_CATEGORY_ERROR
  };
}
export function deleteCategory(categoryId, knowledgeBaseId) {
  return dispatch => {
    dispatch(categoryDeleting());
    return KnowledgeCategoriesApi.delete(categoryId, knowledgeBaseId).then(() => {
      return dispatch(categoryDeleted());
    }, error => {
      dispatch(categoryDeleteRequestFailed(error));
      return Promise.reject(error);
    });
  };
}
function categoryUpdated(payload) {
  return {
    payload,
    type: ActionTypes.UPDATE_CATEGORY_SUCCESS
  };
}
function categoryUpdating() {
  return {
    type: ActionTypes.UPDATE_CATEGORY_PENDING
  };
}
function categoryUpdateRequestFailed(error) {
  return {
    error,
    type: ActionTypes.UPDATE_CATEGORY_ERROR
  };
}

// used for updating category and subcategory name/description
export function updateCategory(categoryId, data) {
  return dispatch => {
    dispatch(categoryUpdating());
    return KnowledgeCategoriesApi.update(categoryId, data).then(response => {
      dispatch(categoryUpdated(response));
      return Promise.resolve(response);
    }, error => {
      dispatch(categoryUpdateRequestFailed(error));
      return Promise.reject(error);
    });
  };
}
export function updateCategoryFromTemplateEditor(categoryId, data) {
  return dispatch => {
    dispatch(categoryUpdating());
    return KnowledgeCategoriesApi.update(categoryId, data).then(response => {
      dispatch(templatePreviewShowLoadingOverlay());
      dispatch(categoryUpdated(response));
      dispatch(templatePreviewTriggerIFrameReload());
      return Promise.resolve(response);
    }, error => {
      dispatch(categoryUpdateRequestFailed(error));
      return Promise.reject(error);
    });
  };
}